/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-03-13 13:48:12
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { formatNumberInThousand, formatNumberWithMoney } from 'src/helpers';
import Percent from 'src/components/views/analytics/percent';

type Props = {
  type: string,
  compare: boolean,
  listCollection: Array<Object>
};

type ComposedProps = Props & WithI18nProps;
class TopCollection extends Component<ComposedProps> {
  renderRowForCompactView(index, item, compare) {
    const { collectionLabel, percentChange, total } = item;
    const { isMoneyFormat = false } = this.props;
    return (
      <tr key={index}>
        <td className="item-first-col">
          <div>
            <span className="range">{index + 1}.</span>
            <div>{collectionLabel}</div>
          </div>
        </td>
        {compare ? (
          <td className="item-percentage">
            <Percent percent={percentChange} />
          </td>
        ) : (
          <td />
        )}
        <td className="item-total">
          <TextStyle>
            <span
              dangerouslySetInnerHTML={{
                __html: isMoneyFormat
                  ? formatNumberWithMoney(formatNumberInThousand(total))
                  : formatNumberInThousand(total)
              }}></span>
          </TextStyle>
        </td>
      </tr>
    );
  }

  renderRowForDetailView(index, item, compare, fromIndex) {
    const { collectionLabel, percentChange, total } = item;
    const { isMoneyFormat = false } = this.props;

    return (
      <tr key={index}>
        <td className="item-first-col">
          <div>
            <span className="range">{index + fromIndex + 1}.</span>
            <div>{collectionLabel}</div>
          </div>
        </td>
        <td className="item-total">
          <TextStyle>
            <span
              dangerouslySetInnerHTML={{
                __html: isMoneyFormat
                  ? formatNumberWithMoney(formatNumberInThousand(total))
                  : formatNumberInThousand(total)
              }}></span>
          </TextStyle>
        </td>
        {compare ? (
          <td className="item-percentage">
            <Percent percent={percentChange} />
          </td>
        ) : (
          <td />
        )}
      </tr>
    );
  }

  renderTableForCompactView(listCollection, compare) {
    const cloned = [...listCollection];
    const subList = cloned.splice(0, 3);
    return (
      <div className="content-compact-content">
        <table className="Polaris-DataTable__Table">
          <tbody>
            {subList.map((item, index) => this.renderRowForCompactView(index, item, compare))}
          </tbody>
        </table>
      </div>
    );
  }

  renderTableForDetailView(listCollection, compare) {
    const length = listCollection.length;
    // Split array into sub 2 arrays
    const cloned = [...listCollection];
    const subList = cloned.splice(0, Math.round(length / 2));

    return (
      <div className="content-compact-content">
        {/* Left column */}
        <div className="content-compact-content-item first">
          <table className="Polaris-DataTable__Table">
            <tbody>
              {subList.map((item, index) => this.renderRowForDetailView(index, item, compare, 0))}
            </tbody>
          </table>
        </div>

        {/* Right column */}
        <div className="content-compact-content-item">
          <table className="Polaris-DataTable__Table">
            <tbody>
              {cloned.map((item, index) =>
                this.renderRowForDetailView(index, item, compare, subList.length)
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  render() {
    const { type, compare, listCollection, i18n } = this.props;

    return (
      <div className="content content-compact">
        <div className="content-compact-title">
          <span>{i18n.translate('AdminHTML.Analytics.Display.topCollection_Title')}</span>
        </div>

        {type === 'compact'
          ? this.renderTableForCompactView(listCollection, compare)
          : this.renderTableForDetailView(listCollection, compare)}
      </div>
    );
  }
}

export default withI18n()(TopCollection);
